/**
 * Public contact address — shown on the landing page, and where the contact
 * form delivers when CONTACT_EMAIL isn't set (see src/lib/email.ts).
 */
export const CONTACT_ADDRESS = "hello@lastredirect.com";

/**
 * Subject options offered by the landing page's "Get in touch" form. Shared by
 * the form and POST /api/contact so the two can't drift apart — the route
 * validates against this exact list.
 */
export const CONTACT_TOPICS = [
  "General question",
  "Billing & plans",
  "Technical support",
] as const;

export type ContactTopic = (typeof CONTACT_TOPICS)[number];
